/** Build executive overview from successful domain API responses only (no zero placeholders). */

const defined = (v) => v !== undefined && v !== null && v !== "";

export const buildOverviewFromDomains = (identity, infrastructure, teacher, operational) => {
  const identitySummary = identity?.summary;
  const infraSummary = infrastructure?.summary;
  const teacherSummary = teacher?.summary;
  const operationalSummary = operational?.summary;

  const hasAny =
    identitySummary ||
    infraSummary ||
    teacherSummary ||
    operationalSummary ||
    infrastructure?.classroom_metrics ||
    identity?.aadhaar_metrics;

  if (!hasAny) return null;

  const quick_stats = {};
  if (defined(identitySummary?.total_schools)) quick_stats.total_schools = identitySummary.total_schools;
  else if (defined(infraSummary?.total_schools)) quick_stats.total_schools = infraSummary.total_schools;

  if (defined(identitySummary?.total_students)) quick_stats.total_students = identitySummary.total_students;
  else if (defined(operationalSummary?.total_students)) quick_stats.total_students = operationalSummary.total_students;

  if (defined(teacherSummary?.total_teachers)) quick_stats.total_teachers = teacherSummary.total_teachers;
  if (defined(infrastructure?.classroom_metrics?.total_classrooms)) {
    quick_stats.total_classrooms = infrastructure.classroom_metrics.total_classrooms;
  } else if (defined(infraSummary?.total_classrooms)) {
    quick_stats.total_classrooms = infraSummary.total_classrooms;
  }
  if (defined(infraSummary?.total_toilets)) quick_stats.total_toilets = infraSummary.total_toilets;

  const domain_summary = {};
  if (identitySummary || identity?.aadhaar_metrics || identity?.apaar_metrics) {
    domain_summary.identity = {
      ...(defined(identitySummary?.identity_compliance_index)
        ? { index: identitySummary.identity_compliance_index }
        : {}),
      ...(defined(identity?.aadhaar_metrics?.aadhaar_coverage_pct)
        ? { aadhaar_pct: identity.aadhaar_metrics.aadhaar_coverage_pct }
        : {}),
      ...(defined(identity?.apaar_metrics?.apaar_coverage_pct)
        ? { apaar_pct: identity.apaar_metrics.apaar_coverage_pct }
        : {}),
    };
  }
  if (infraSummary || infrastructure?.classroom_metrics || infrastructure?.toilet_metrics) {
    domain_summary.infrastructure = {
      ...(defined(infraSummary?.infrastructure_index)
        ? { index: infraSummary.infrastructure_index }
        : {}),
      ...(defined(infrastructure?.classroom_metrics?.classroom_health_pct)
        ? { classroom_health: infrastructure.classroom_metrics.classroom_health_pct }
        : {}),
      ...(defined(infrastructure?.toilet_metrics?.functional_pct)
        ? { toilet_functional: infrastructure.toilet_metrics.functional_pct }
        : {}),
    };
  }
  if (teacherSummary || teacher?.compliance_metrics) {
    domain_summary.teacher = {
      ...(defined(teacherSummary?.teacher_quality_index)
        ? { index: teacherSummary.teacher_quality_index }
        : {}),
      ...(defined(teacherSummary?.total_teachers)
        ? { total_teachers: teacherSummary.total_teachers }
        : {}),
      ...(defined(teacher?.compliance_metrics?.ctet_pct)
        ? { ctet_pct: teacher.compliance_metrics.ctet_pct }
        : {}),
    };
  }
  if (operationalSummary || operational?.data_entry_metrics) {
    domain_summary.operational = {
      ...(defined(operationalSummary?.operational_index)
        ? { index: operationalSummary.operational_index }
        : {}),
      ...(defined(operational?.data_entry_metrics?.completion_rate)
        ? { completion_rate: operational.data_entry_metrics.completion_rate }
        : {}),
      ...(defined(operational?.data_entry_metrics?.certification_rate)
        ? { certification_rate: operational.data_entry_metrics.certification_rate }
        : {}),
    };
  }

  return { quick_stats, domain_summary };
};
